const getHasValidDateFormat = value =>
  /^(?:0[1-9]|1[0-2])\/(?:0[1-9]|[1-2][0-9]|3[0-1])\/(?:1[8-9][0-9]{2}|2[0-9]{3})$/.test(
    value
  )

export default getHasValidDateFormat
